import { useState } from 'react';
import { Toast } from 'antd-mobile';
import i18n from '../../../i18n';
import { useAuth } from '../../../hooks/useAuth';
import { LoginFormValues } from './types';

export function useLoginModel() {
  const { doLogin } = useAuth();
  const [loading, setLoading] = useState(false);

  const submit = async (values: LoginFormValues) => {
    setLoading(true);
    try {
      await doLogin(values.username, values.password);
      Toast.show({ icon: 'success', content: i18n.t('auth:login.successToast') });
    } catch (error: any) {
      Toast.show({
        icon: 'fail',
        content: error?.response?.data?.error?.message || i18n.t('auth:login.failedToast'),
      });
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    submit,
  };
}
